import { useAuth } from '@/features/auth/hooks/useAuth'
import { UserRole } from '@/types/entities'
import { ManagerDashboard } from '../components/ManagerDashboard'
import { ArtistDashboard } from '../components/ArtistDashboard'

export function Dashboard() {
  const { user } = useAuth()

  if (!user) return null

  if (user.role === UserRole.MANAGER) {
    return <ManagerDashboard />
  }

  return <ArtistDashboard />
}

